import { createRoot } from "react-dom/client";
import "regenerator-runtime/runtime";
import "core-js/stable";

import "@styles/global.css";
import useSystemStore from "@store/useSystemStore";
import { detectDarkTheme } from "@platform/utils/theme.util";
import App from "./App";

/* global document, Office, module, require, HTMLElement */

const rootElement: HTMLElement | null = document.getElementById("root");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes.
 * Guard against non-Office loads — link previewers, Microsoft Defender Safe Links
 * scanners, and direct browser navigation to taskpane.html all load this bundle
 * without an Office host. Without this guard, `Office` is undefined and the bare
 * reference throws ReferenceError before the app can mount or Bugsnag can init. */
if (typeof Office !== "undefined" && Office.onReady) {
  Office.onReady(() => {
    const { setIsDarkMode } = useSystemStore.getState();

    setIsDarkMode(detectDarkTheme());

    root?.render(<App />);
  });
}

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    root?.render(NextApp);
  });
}
